var map = {
	"./_icon.svg": "./public/icons/_icon.svg",
	"./angle-down.svg": "./public/icons/angle-down.svg",
	"./community-success.svg": "./public/icons/community-success.svg",
	"./cultural.svg": "./public/icons/cultural.svg",
	"./entrepreneurship.svg": "./public/icons/entrepreneurship.svg",
	"./financial-freedom.svg": "./public/icons/financial-freedom.svg",
	"./higher-income-careers.svg": "./public/icons/higher-income-careers.svg",
	"./live-off-land.svg": "./public/icons/live-off-land.svg",
	"./loading-blue.svg": "./public/icons/loading-blue.svg",
	"./loading.svg": "./public/icons/loading.svg",
	"./mana.svg": "./public/icons/mana.svg",
	"./manaakitanga.svg": "./public/icons/manaakitanga.svg",
	"./maori-leadership.svg": "./public/icons/maori-leadership.svg",
	"./mea-ngaro.svg": "./public/icons/mea-ngaro.svg",
	"./ngati-rangitanga.svg": "./public/icons/ngati-rangitanga.svg",
	"./rau-kotahi.svg": "./public/icons/rau-kotahi.svg",
	"./reconnect-to-taiao.svg": "./public/icons/reconnect-to-taiao.svg",
	"./social.svg": "./public/icons/social.svg",
	"./sustainable-business.svg": "./public/icons/sustainable-business.svg",
	"./tari.svg": "./public/icons/tari.svg",
	"./te-ao-turoa.svg": "./public/icons/te-ao-turoa.svg",
	"./te-reo-māori.svg": "./public/icons/te-reo-māori.svg",
	"./tikanga.svg": "./public/icons/tikanga.svg",
	"./turangawaewae.svg": "./public/icons/turangawaewae.svg",
	"./values-based-living.svg": "./public/icons/values-based-living.svg",
	"./whānau-ora.svg": "./public/icons/whānau-ora.svg",
	"./whānua-hubs.svg": "./public/icons/whānua-hubs.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/icons sync recursive .svg";